import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AlertDialog = (props) => {
  const title = props.alertTitle;
  const message = props.alertMessage;
  const showCancel = props.showCancel;
  const options = {
    maxWidth: undefined,
    fullWidth: undefined,
    zIndex: 1315,
    ...props.options
  };
  function handleClose() {
    if (props.onConfirm){
      props.onConfirm();
    }
    props.onChange();
  }
  function handleCancel() {
    if (props.onCancel){
      props.onCancel();
    }
    props.onChange();
  }

  return (
    <div>
      <Dialog id="alert-dialog-slide"
        style={{zIndex: options.zIndex}}
        PaperProps={{style:{...options.dialogStyle}}}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={(event, reason) => {if (reason !== 'backdropClick') handleClose()}}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        // disableBackdropClick={true}
        maxWidth={options.maxWidth}
        fullWidth={options.fullWidth}
      >
        <DialogTitle id="alert-dialog-slide-title" style={{...options.titleStyle}}>{title}</DialogTitle>
        <DialogContent style={{...options.contentStyle}}>
          <DialogContentText id="alert-dialog-slide-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          { showCancel?(
              <Button onClick={handleCancel} color="primary">Cancel</Button>
            ):(<div></div>)
          }
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AlertDialog;
